const clearSiteData = async () => {
  const response = await fetch('/clear-site-data');
  if (response.ok) {
    window.location.reload();
  }
};

export default clearSiteData;
